import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

  const BookingSummary = ({
    bookingData,
    onConfirm,
    onEdit,
    isKpbRequired = false,
    kpbLevel = null
  }) => {

  const isDisabled =
    !bookingData?.serviceName ||
    !bookingData?.date ||
    !bookingData?.time ||
    (isKpbRequired && !kpbLevel);


  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 sticky top-24">
      <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-6">
        Ringkasan Booking
      </h3>
      <div className="space-y-4 mb-6">
        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Wrench" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground mb-1">Jenis Service</p>
            <p className="text-sm md:text-base font-heading font-semibold text-foreground">
              {bookingData?.serviceName ?? '-'}
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground mb-1">Tanggal & Waktu</p>
            <p className="text-sm md:text-base font-heading font-semibold text-foreground">
              {bookingData?.date && bookingData?.time
                ? `${bookingData?.date} - ${bookingData?.time} WIB`
                : '-'}
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground mb-1">Service Advisor</p>
            <p className="text-sm md:text-base font-heading font-semibold text-foreground">
              {bookingData?.advisorName || '-'}
            </p>
          </div>
        </div>

        <div className="flex items-start space-x-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Bike" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-xs text-muted-foreground mb-1">Motor</p>
            <p className="text-sm md:text-base font-heading font-semibold text-foreground">
              {bookingData?.motorModel || '-'}
            </p>
            <p className="text-xs text-muted-foreground">
              {bookingData?.plateNumber || '-'}
            </p>
          </div>
        </div>
      </div>
      <div className="pt-4 border-t border-border mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Biaya Service</span>
          <span className="text-sm font-semibold text-foreground">
            {bookingData?.serviceName ? `Rp ${bookingData.servicePrice.toLocaleString('id-ID')}` : '-'}
          </span>
        </div>
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm text-muted-foreground">Estimasi Suku Cadang</span>
          <span className="text-sm font-semibold text-foreground">
            {bookingData?.serviceName
              ? `Rp ${bookingData.partsEstimate.toLocaleString('id-ID')}`
              : '-'}
          </span>
        </div>
        <div className="flex items-center justify-between pt-3 border-t border-border">
          <span className="text-base font-heading font-bold text-foreground">
            Total Estimasi
          </span>
          <span className="text-lg md:text-xl font-heading font-bold text-primary">
            {bookingData?.serviceName
              ? `Rp ${bookingData.totalEstimate.toLocaleString('id-ID')}`
              : '-'}
          </span>
        </div>
      </div>
      <div className="space-y-3">
        <Button
          variant="default"
          size="lg"
          fullWidth
          iconName="Check"
          iconPosition="left"
          onClick={onConfirm}
          disabled={isDisabled}
        >
          Konfirmasi Booking
        </Button>
        {isKpbRequired && !kpbLevel && (
          <p className="text-xs text-red-500 text-center">
            Silakan pilih jenis KPB (I–IV) sebelum konfirmasi booking.
          </p>
        )}

        <Button
          variant="outline"
          size="lg"
          fullWidth
          iconName="Edit"
          iconPosition="left"
          onClick={onEdit}
        >
          Edit Booking
        </Button>
      </div>
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <p className="text-xs text-muted-foreground">
            Estimasi biaya dapat berubah setelah pemeriksaan detail oleh teknisi kami. 
            Anda akan dihubungi untuk konfirmasi sebelum pekerjaan dimulai.
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookingSummary;